import request from '@/router/axios'

const base = '/api/produce/arrival-analysis'

/** 到站车厢数趋势（折线）：title、trainCount、weightSum，trainCount 为车厢数汇总 */
export const fetchArrivalTrend = (data) =>
  request({ url: `${base}/arrivalTrend`, method: 'post', data })

/** 煤種到站量對比（柱狀）：title、data 為噸位 */
export const fetchCargoBar = (data) =>
  request({ url: `${base}/arrivalModeDistribute`, method: 'post', data })

/** 到站明細分頁 */
export const fetchArrivalDetailPage = (data) =>
  request({ url: `${base}/arrivalDetailPage`, method: 'post', data })

/** 底部汇总：totalTrains、totalWeight、cargoPie[{name,weight,percent}]，totalTrains 为车厢数汇总 */
export const fetchArrivalSummary = (data) =>
  request({ url: `${base}/arrivalSummary`, method: 'post', data })

/** 煤种远程检索 */
export const searchVardictPycode = (varName) =>
  request({
    url: '/api/produce/vardict/select/distinct/pycode',
    method: 'get',
    params: {
      varName: varName != null ? String(varName) : '',
      page: 1,
      size: 50
    }
  })
